import { Box, Flex, Text } from '@chakra-ui/react';
import { usePrice } from '../../../hooks/usePrice';
import { Carousel } from '../../Trends/Carousel';
import { TokenCardSkeleton } from '../../Trends/TokenCardSkeleton';
import trendsBg from '../../../assets/image/home/trends-bg.png';

const NewHomeTrend = () => {
  const { isSuccess, data: result } = usePrice();
  const handleButtonClick = () => {
    const url = 'https://app.alloydex.com';
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  return (
    <Flex width="100%" flexDir="column">
      <Flex
        width="100%"
        flexDir="column"
        gap={{ base: '30px', md: '52px' }}
        justifyContent="center"
        aspectRatio={1440 / 405}
        bgPos="center"
        backgroundImage={trendsBg}
        bgRepeat="no-repeat"
        bgSize="cover">
        <Text
          fontFamily="Georgia"
          fontSize={['24px', null, '66px']}
          align={'center'}
          color="white"
          data-aos="fade-down"
          data-aos-once={true}>
          Market Trends
        </Text>
        <Box
          bg={'#394DEE'}
          color={'#fff'}
          width={{ base: '150px', md: '176px' }}
          height={{ base: '40px', md: '72px' }}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          fontWeight={400}
          borderRadius="full"
          margin={'0 auto'}
          cursor={'pointer'}
          onClick={handleButtonClick}>
          Trade now
        </Box>
      </Flex>
      <Box py="49px" px="36px" borderBottom="1px solid #505050">
        {isSuccess ? (
          <Carousel items={result!} />
        ) : (
          <Flex width="100%" alignItems="center" justifyContent="center" gap="30px" overflow={'hidden'}>
            {[...Array(3).keys()].map((item) => {
              return <TokenCardSkeleton key={item} />;
            })}
          </Flex>
        )}
      </Box>
    </Flex>
  );
};

export default NewHomeTrend;
